import { useEffect } from "react";
import Lenis from "lenis";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Manifesto } from "@/components/landing/Manifesto";
import { Formation } from "@/components/landing/Formation";
import { Pricing } from "@/components/landing/Pricing";
import { Footer } from "@/components/landing/Footer";

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <main className="relative min-h-screen overflow-x-clip bg-[#020A1A] font-sans text-[#DCE8FF] antialiased">
      <div className="grain pointer-events-none fixed inset-0 z-50" aria-hidden="true" />
      <Hero />
      <Marquee />
      <Manifesto />
      <Formation />
      <Pricing />
      <Footer />
    </main>
  );
}
